/* @ngInject */
function AssetPreviewPdfController ($scope, $timeout, $rootScope, $interval, $attrs, NewAssetService, AssetPreviewService, SegmentService) {
  const pdfjsLib = require('pdfjs-dist')

  // The workerSrc property shall be specified.
  pdfjsLib.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString()

  $scope.showNextButton = true
  $scope.showPreviousButton = true
  $scope.selectedPage = 1
  $scope.pdfScale = 1
  $scope.pdfScaleRatio = 0.25
  var pdfheight = $scope.contextData.internalApproval ? 500 : 620
  $scope.pdfDimensions = {
    height: 0,
    width: 0
  }
  $scope.pdfRenderWidth = 0
  $scope.pagesMaxHeight = 0
  $scope.top = 10
  $scope.skip = 0
  $scope.renderPromises = []

  $scope.pdf = {}
  $scope.pdfPagesArray = []
  $scope.panConfig = {
    elViewport: null,
    elCanvas: null,
    offset: { x: 0, y: 0 },
    isPan: null,
    isVertical: false,
    isHorizontal: false,
    pdfSizeDiffX: 0,
    pdfSizeDiffY: 0
  }

  $scope.flags = {
    zoomOut: false,
    loading: true,
    isFullscreen: false,
    hasMorePages: true
  }

  $scope.location = $scope.location || 'materials'
  $scope.isSingleTab = $scope.location === 'materials' && $rootScope.isUser()

  const api = {
    _handlePDFAsset,
    _generatePDF,
    _handlePagesThumbnails,
    _updatePdfScale,
    _resetPdfScale,
    _checkVerticalOverflow,
    _checkHorizontalOverflow,
    _getPdfPanningConfigs,
    _handlePdfPanning,
    _handlePanningScale,
    _handleInitialScale,
    _panStart,
    _panMove,
    _panEnd,
    _subtract,
    _initObserverShowMore,
    _verifyIntersectionButton,
    _getMorePages,
    _createArray,
    _hasMorePages,
    _addPages,
    _handleMuiltiplePages,
    _handleKeyboardNavigation,
    _getPdfDimensions,
    _renderPage,
    _isAlreadyRendering,
    _isElementInView,
    _handleLayersScrollSet,
    _getPDFMaxSize,
    _getPdfScale,
    _handlePdfCommentsPins,
    _addEventListenerToOtherElements,
    _removeEventListenerFromOtherElements
  }

  this.getApi = () => api

  $scope.$watch('previewFlags.isAddingAnnotation', () => {
    if ($scope.previewFlags.isAddingAnnotation) {
      $scope.pdfScale = 1
      api._updatePdfScale()
    }
  })

  $scope.$watchCollection('template', () => {
    $scope.flags.loading = true
    const isTemplate = !$scope.template.assetId || $scope.template.assetId !== $scope.template.id

    if ($scope.template.extension === 'pdf') {
      api._handlePDFAsset(isTemplate)
      api._resetPdfScale()
    }
  })

  const deregisterReloadPreview = $rootScope.$on('asset-preview-dialog.reload-preview-details', () => {
    const isTemplate = !$scope.template.assetId || $scope.template.assetId !== $scope.template.id

    const interval = $interval(() => {
      NewAssetService.checkAssetHasThumb($scope.template.id, 'HIGH').then((hasThumb) => {
        if (!hasThumb) {
          return
        }

        $interval.cancel(interval)
        $rootScope.$emit(`asset-card-${$scope.template.id}.update-asset-thumbnail`)
      })
    }, 8000)

    api._handlePDFAsset(isTemplate)
    api._resetPdfScale()
  })

  $scope.$watchGroup(['previewFlags.navigationIsOpen', 'previewFlags.showVersionControl'], () => {
    const { navigationIsOpen, showVersionControl } = $scope.previewFlags

    pdfheight = api._getPDFMaxSize(showVersionControl)

    if ($scope.pdf.pdfDoc) {
      api._generatePDF($scope.pdf.canvas, $scope.pdf.numPage, navigationIsOpen, pdfheight)
    }

    document.addEventListener('keydown', api._handleKeyboardNavigation)
  })

  function _handleKeyboardNavigation (ev) {
    if (ev.code === 'ArrowDown' && ev.which === 40) {
      $scope.nextPage()
    }

    if (ev.code === 'ArrowUp' && ev.which === 38) {
      $scope.previousPage()
    }
  }

  $scope.$on('$destroy', () => {
    document.removeEventListener('keydown', api._handleKeyboardNavigation)
    $scope.pdf.pdfDoc.destroy()
    deregisterReloadPreview()
    api._removeEventListenerFromOtherElements()
  })

  function _handlePDFAsset (isTemplate) {
    let nameRoute = null

    if (isTemplate) {
      nameRoute = AssetPreviewService.getArtPreview($scope.template.id, null, { quality: 'ORIGINAL' })
    } else {
      const moduleLocation = AssetPreviewService.getModuleForLocation($scope.location)
      nameRoute = AssetPreviewService.getAssetPreview($scope.template.id, moduleLocation, { quality: 'ORIGINAL' })
    }

    $scope.pdf.loadingTask = pdfjsLib.getDocument({
      url: nameRoute,
      disableStream: true,
      disableAutoFetch: true,
      // iccUrl: '../../../assets/icc-profiles/',
      // wasmUrl: '../../../assets/wasm/',
      // useWasm: true,
      useWorkerFetch: true
    })

    $scope.pdf.scale = 1
    $scope.pdf.numPage = 1

    $scope.pdf.loadingTask.promise.then(pdfDoc_ => {
      $scope.pdf.pdfDoc = pdfDoc_
      $scope.pdf.canvas = document.querySelector('#previewCanvaMain')
      $scope.pdf.ctx = $scope.pdf.canvas.getContext('2d')
      api._handleMuiltiplePages()
      api._generatePDF($scope.pdf.canvas, $scope.pdf.numPage, $scope.previewFlags.navigationIsOpen, pdfheight)

      $timeout(() => {
        api._initObserverShowMore()
        api._handlePagesThumbnails($scope.pdfPagesArray)
      }, 200, false)
    })
  }

  function _generatePDF (canvas, numPage, navigation, maxSize) {
    $scope.pdf.pdfDoc.getPage(numPage).then(page => {
      if (!api._isAlreadyRendering(page._pageIndex)) {
        api._renderPage(page, canvas, navigation, maxSize)
      }
    })

    const pdfEl = document.querySelector('.asset-pdf-preview__pdf--wrapper canvas')
    if (pdfEl) {
      const hasVerticalOverflow = api._checkVerticalOverflow(pdfEl)
      const hasHorizontalOverflow = api._checkHorizontalOverflow(pdfEl)

      api._handlePdfPanning(hasVerticalOverflow, hasHorizontalOverflow)
    }
  }

  function _renderPage (page, canvas, navigation, maxSize) {
    const isPagesThumbnail = maxSize === 100
    const pdfScale = api._getPdfScale(page, navigation, maxSize)

    if (!isPagesThumbnail) {
      $scope.pdfDimensions = api._getPdfDimensions(page, navigation, maxSize)
    }

    const viewport = page.getViewport({ scale: pdfScale })
    canvas.width = viewport.width
    canvas.height = viewport.height

    $timeout(() => {
      $scope.flags.loading = false
    }, 0)

    const renderingTask = page.render({
      canvasContext: canvas.getContext('2d'),
      viewport
    }).promise

    renderingTask.then(() => {
      $scope.renderPromises = $scope.renderPromises.filter((task) => {
        return task.page !== page._pageIndex
      })
    })

    $scope.renderPromises.push({
      page: page._pageIndex,
      renderingTask
    })
  }

  function _isAlreadyRendering (pageIndex) {
    return $scope.renderPromises.some(item => {
      return item.page === pageIndex
    })
  }

  function _getPdfScale (page, navigation, maxSize) {
    const viewport = page.getViewport({ scale: 1.0 })
    const originalHeight = viewport.height
    const originalWidth = viewport.width
    var baseScale

    if (originalHeight >= originalWidth) {
      const padding = 80
      const height = navigation ? maxSize - padding : maxSize
      baseScale = height / originalHeight
    } else {
      baseScale = maxSize / originalWidth
    }

    return baseScale * $scope.pdfScale
  }

  function _getPdfDimensions (page, navigation, maxSize) {
    const pdfScale = api._getPdfScale(page, navigation, maxSize)
    const viewport = page.getViewport({ scale: pdfScale })
    const dimensions = {
      height: viewport.height,
      width: viewport.width
    }

    return dimensions
  }

  function _handleMuiltiplePages () {
    if ($scope.top > $scope.pdf.pdfDoc.numPages) {
      $scope.pdfPagesArray = api._createArray(1, $scope.pdf.pdfDoc.numPages)
      $scope.skip = $scope.pdf.pdfDoc.numPages
      $scope.flags.hasMorePages = false
    }

    if ($scope.top < $scope.pdf.pdfDoc.numPages) {
      $scope.pdfPagesArray = api._createArray(1, $scope.top)
      $scope.skip = $scope.top
    }
  }

  function _handlePagesThumbnails (pages) {
    pages.forEach(thumbnail => {
      const thumbnailCanvas = document.querySelector(`#previewCanva${thumbnail}`)
      api._generatePDF(thumbnailCanvas, thumbnail, false, 100, 100)
    })
    const { internalApproval } = $scope.contextData
    const pagesPadding = internalApproval ? 285 : 185

    $scope.pagesMaxHeight = `${window.innerHeight - pagesPadding}px`
  }

  $scope.setPageView = (page) => {
    $scope.pdf.numPage = page
    api._generatePDF($scope.pdf.canvas, page, $scope.previewFlags.navigationIsOpen, pdfheight)

    SegmentService.track('arts-preview-interact', { interact_type: 'pagination', type: $scope.template.isCustomizable ? 'customizable' : 'upload' })
  }

  $scope.zoomOut = () => {
    if ($scope.pdfScale > $scope.pdfScaleRatio) {
      SegmentService.track('arts-preview-interact', { interact_type: 'zoom', type: $scope.template.isCustomizable ? 'customizable' : 'upload' })

      $scope.pdfScale = $scope.pdfScale - $scope.pdfScaleRatio
      $scope.flags.zoomOut = true
      api._updatePdfScale()
    }
  }

  $scope.zoomIn = () => {
    if ($scope.pdfScale < 4) {
      SegmentService.track('arts-preview-interact', { interact_type: 'zoom', type: $scope.template.isCustomizable ? 'customizable' : 'upload' })

      $scope.pdfScale = $scope.pdfScale + $scope.pdfScaleRatio
      api._updatePdfScale()
    }
  }

  function _updatePdfScale () {
    if ($scope.pdf.pdfDoc && $scope.pdf.numPage) {
      api._generatePDF($scope.pdf.canvas, $scope.pdf.numPage, $scope.previewFlags.navigationIsOpen, pdfheight)
    }
  }

  function _resetPdfScale () {
    $scope.pdfScale = 1

    $scope.panConfig.offset.x = 0
    $scope.panConfig.offset.y = 0
    if ($scope.panConfig.elCanvas) {
      $scope.panConfig.elCanvas.style.translate = `${$scope.panConfig.offset.x}px ${$scope.panConfig.offset.y}px`
    }

    if ($scope.pdf.pdfDoc && $scope.pdf.numPage) {
      api._generatePDF($scope.pdf.canvas, $scope.pdf.numPage, $scope.previewFlags.navigationIsOpen, pdfheight)
    }
  }

  function _checkVerticalOverflow (elem) {
    const elemHeight = elem.getBoundingClientRect().height
    const parentHeight = elem.parentElement.getBoundingClientRect().height

    return elemHeight > parentHeight
  }

  function _checkHorizontalOverflow (elem) {
    const elemWidth = elem.getBoundingClientRect().width
    const parent = document.querySelector('.asset-pdf-preview__pdf--container')
    const parentWidth = parent.getBoundingClientRect().width

    return elemWidth > parentWidth
  }

  function _getPdfPanningConfigs (isVertical, isHorizontal) {
    $scope.panConfig.elViewport = document.querySelector('.asset-pdf-preview__pdf--wrapper')

    $scope.panConfig.elCanvas = $scope.panConfig.elViewport.querySelector('canvas')
    $scope.panConfig.isPan = false
    $scope.panConfig.isHorizontal = isHorizontal
    $scope.panConfig.isVertical = isVertical
    $scope.panConfig.pdfSizeDiffX = $scope.panConfig.elCanvas.width * $scope.pdfScaleRatio
    $scope.panConfig.pdfSizeDiffY = $scope.panConfig.elCanvas.height * $scope.pdfScaleRatio
  }

  function _handlePdfPanning (isVertical, isHorizontal) {
    api._getPdfPanningConfigs(isVertical, isHorizontal)
    api._handlePanningScale()

    if (isVertical || isHorizontal) {
      $scope.panConfig.elViewport.addEventListener('pointerdown', api._panStart)
      $scope.panConfig.elViewport.addEventListener('pointermove', api._panMove)
      $scope.panConfig.elViewport.addEventListener('pointerup', api._panEnd)
      api._addEventListenerToOtherElements()
    } else {
      $scope.panConfig.elViewport.removeEventListener('pointerdown', api._panStart)
      $scope.panConfig.elViewport.removeEventListener('pointermove', api._panMove)
      $scope.panConfig.elViewport.removeEventListener('pointerup', api._panEnd)
      api._removeEventListenerFromOtherElements()
    }
  };

  function _handlePanningScale () {
    if ($scope.flags.zoomOut) {
      if (!$scope.panConfig.isHorizontal) {
        $scope.panConfig.offset.x = 0
      }

      if (!$scope.panConfig.isVertical) {
        $scope.panConfig.offset.y = 0
      }

      if ($scope.panConfig.offset.x !== 0) {
        $scope.panConfig.offset.x = api._subtract($scope.panConfig.offset.x, $scope.panConfig.pdfSizeDiffX / 2)
      }

      if ($scope.panConfig.offset.y !== 0) {
        $scope.panConfig.offset.y = api._subtract($scope.panConfig.offset.y, $scope.panConfig.pdfSizeDiffY / 2)
      }

      if ($scope.panConfig.elCanvas) {
        $scope.panConfig.elCanvas.style.translate = `${$scope.panConfig.offset.x}px ${$scope.panConfig.offset.y}px`
      }
      $scope.flags.zoomOut = false
    }
  }

  function _subtract (minuend = 0, subtrahend = 0) {
    const isNegative = Math.sign(minuend) === -1

    if (isNegative) {
      return minuend + subtrahend
    }

    return minuend - subtrahend
  }

  function _panStart (ev) {
    ev.preventDefault()
    $scope.panConfig.isPan = true
  };

  function _panMove (ev) {
    if (!$scope.panConfig.isPan) return

    if ($scope.panConfig.isVertical) {
      const { elViewport, elCanvas } = $scope.panConfig
      const canvasHeight = elCanvas.getBoundingClientRect().height
      const viewportHeight = elViewport.getBoundingClientRect().height
      const movingUp = $scope.panConfig.offset.y > 0

      const MAX_HEIGHT_OFFSET_UP = 1
      const MARGIN = 32
      const maxHeightOffset = Math.max(0, (canvasHeight - viewportHeight)) + MARGIN

      const absY = Math.abs($scope.panConfig.offset.y + ev.movementY)

      if (movingUp && absY <= MAX_HEIGHT_OFFSET_UP) {
        $scope.panConfig.offset.y += ev.movementY
      } else if (!movingUp && absY <= maxHeightOffset) {
        $scope.panConfig.offset.y += ev.movementY
      }
    }

    if ($scope.panConfig.isHorizontal) {
      const { elViewport, elCanvas } = $scope.panConfig
      const canvasWidth = elCanvas.getBoundingClientRect().width
      const viewportWidth = elViewport.getBoundingClientRect().width
      const movingLeft = $scope.panConfig.offset.x > 0

      const maxWidthOffset = Math.max(0, (canvasWidth - viewportWidth))
      const MARGIN_LEFT = 32
      const MARGIN_RIGHT = 100
      const absX = Math.abs($scope.panConfig.offset.x + ev.movementX)

      if (movingLeft && absX <= maxWidthOffset + MARGIN_LEFT) {
        $scope.panConfig.offset.x += ev.movementX
      } else if (!movingLeft && absX <= maxWidthOffset - MARGIN_RIGHT) {
        $scope.panConfig.offset.x += ev.movementX
      }
    }

    if ($scope.panConfig.elCanvas) {
      $scope.panConfig.elCanvas.style.translate = `${$scope.panConfig.offset.x}px ${$scope.panConfig.offset.y}px`
    }
  };

  function _panEnd () {
    $scope.panConfig.isPan = false
  };

  $scope.previousPage = () => {
    if ($scope.pdf.numPage !== 1) {
      $scope.pdf.numPage = $scope.pdf.numPage - 1
      api._handleLayersScrollSet($scope.pdf.numPage, true)
      $scope.setPageView($scope.pdf.numPage)
    }
  }

  $scope.nextPage = () => {
    if ($scope.pdf.numPage !== $scope.pdfPagesArray.length) {
      $scope.pdf.numPage = $scope.pdf.numPage + 1

      if ($scope.pdf.numPage === $scope.skip) {
        api._getMorePages()
      }

      api._handleLayersScrollSet($scope.pdf.numPage, false)
      $scope.setPageView($scope.pdf.numPage)
    }
  }

  function _handleLayersScrollSet (page, scrollTop) {
    const thumbnailCanvas = document.querySelector(`#previewCanva${page}`)
    const isVisible = api._isElementInView(thumbnailCanvas, false)

    if (!isVisible) {
      thumbnailCanvas.parentElement.scrollIntoView(scrollTop)
    }
  }

  function _isElementInView (elem, partial) {
    var container = $('.asset-pages__wrapper')
    var contHeight = container.height()

    var elemTop = $(elem).offset().top - container.offset().top
    var elemBottom = elemTop + $(elem).height()

    var isTotal = (elemTop >= 0 && elemBottom <= contHeight)
    var isPart = ((elemTop < 0 && elemBottom > 0) || (elemTop > 0 && elemTop <= container.height())) && partial

    return isTotal || isPart
  };

  $scope.toggleFullscreen = () => {
    $scope.flags.isFullscreen = !$scope.flags.isFullscreen

    $timeout(() => {
      if (!$scope.flags.isFullscreen) {
        api._resetPdfScale()
        return
      }

      SegmentService.track('arts-preview-interact', { interact_type: 'expand', type: $scope.template.isCustomizable ? 'customizable' : 'upload' })
      api._handleInitialScale()
      api._updatePdfScale()
    }, 50)
  }

  function _handleInitialScale () {
    api._getPdfPanningConfigs(false, false)
    const { elViewport, elCanvas } = $scope.panConfig
    const heightScale = elViewport.offsetHeight / elCanvas.height
    const widthScale = elViewport.offsetWidth / elCanvas.width
    $scope.pdfScale = heightScale > widthScale ? widthScale : heightScale

    if ($scope.panConfig.offset.x !== 0 || $scope.panConfig.offset.y !== 0) {
      $scope.panConfig.offset.x = 0
      $scope.panConfig.offset.y = 0
      $scope.panConfig.elCanvas.style.translate = `${$scope.panConfig.offset.x}px ${$scope.panConfig.offset.y}px`
    }

    api._updatePdfScale()
  }

  $scope.getPdfScalePercentage = (pdfScale = 0) => {
    const percentage = Math.round(pdfScale * 100)

    return `${percentage}%`
  }

  $scope.getPreviewPagination = (page = 0, totalPages = 0) => {
    return `${page} / ${totalPages}`
  }

  function _initObserverShowMore () {
    const pagesSpinner = $attrs.$$element.find('.pages-spinner')

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.4
    }

    const observer = new IntersectionObserver(api._verifyIntersectionButton, options)

    if (pagesSpinner[0]) {
      observer.observe(pagesSpinner[0])
    }
  }

  function _verifyIntersectionButton ([entry]) {
    if (entry.isIntersecting && entry.intersectionRatio >= 0.4 && $scope.flags.hasMorePages) {
      $timeout(() => {
        api._getMorePages()
      }, 0, true)
    }
  }

  function _getMorePages () {
    let newPagesArray
    if (($scope.top + $scope.skip) > $scope.pdf.pdfDoc.numPages) {
      newPagesArray = api._createArray($scope.skip + 1, $scope.pdf.pdfDoc.numPages)

      $timeout(() => {
        $scope.flags.hasMorePages = false
      }, 0, true)
    } else {
      newPagesArray = api._createArray($scope.skip + 1, $scope.skip + $scope.top)
      $scope.skip = $scope.top + $scope.skip

      $timeout(() => {
        $scope.flags.hasMorePages = true
      }, 0, true)
    }

    api._addPages(newPagesArray)
  }

  function _addPages (newPagesArray) {
    $scope.pdfPagesArray = [
      ...$scope.pdfPagesArray,
      ...newPagesArray
    ]

    $timeout(() => {
      api._handlePagesThumbnails(newPagesArray)
    }, 100, true)
  }

  function _createArray (start, stop) {
    return Array.from({ length: (stop - start) / 1 + 1 }, (_, i) => start + i * 1)
  }

  function _hasMorePages () {
    return ($scope.top + $scope.skip) < $scope.pdf.pdfDoc.numPages
  }

  function _getPDFMaxSize (versionControlOpen) {
    const windowWidth = window.innerHeight
    const generalUserScreenHeight = 1664

    if (versionControlOpen && windowWidth <= generalUserScreenHeight) {
      return 350
    }

    return $scope.contextData.internalApproval ? 500 : 620
  }

  $scope.$watchCollection('previewFlags', () => {
    api._handlePdfCommentsPins()
  })

  function _handlePdfCommentsPins () {
    const { tabsIsOpen, currentTab } = $scope.previewFlags
    $scope.showCommentsPins = tabsIsOpen && currentTab === 'comments'
    $scope.previewFlags.showImageZoomControls = !$scope.showCommentsPins
  }

  $scope.annotationMouseEnter = (pin) => {
    $scope.previewFlags.hoverCommentId = pin.approvalCommentId || pin.assetCommentId
  }

  $scope.annotationMouseLeave = () => {
    $scope.previewFlags.hoverCommentId = null
  }

  $scope.handlePinShow = (pin) => {
    const { currentAssetVersion } = $scope.previewFlags

    if ($scope.showCommentsPins) {
      if (currentAssetVersion) {
        return pin.assetComment.assetVersion === currentAssetVersion
      }
      return true
    }
    return false
  }

  function _addEventListenerToOtherElements () {
    const elements = document.querySelectorAll('.asset-preview-header__wrapper, .asset-preview-tabs__icons--wrapper, .asset-preview-dialog__footer, .asset-pdf-preview__pdf-controls')
    elements.forEach(element => {
      element.addEventListener('pointerup', api._panEnd)
    })
  }

  function _removeEventListenerFromOtherElements () {
    const elements = document.querySelectorAll('.asset-preview-header__wrapper, .asset-preview-tabs__icons--wrapper, .asset-preview-dialog__footer, .asset-pdf-preview__pdf-controls')
    elements.forEach(element => {
      element.removeEventListener('pointerup', api._panEnd)
    })
  }
}

export { AssetPreviewPdfController }
